"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopSection = void 0;
const React = __importStar(require("react"));
const red_brush_png_1 = __importDefault(require("@assets/red-brush.png"));
const token_hooks_1 = require("@hooks/token.hooks");
const button_1 = require("@shared-modules/components/button");
const react_1 = require("react");
const translation_hooks_1 = require("@hooks/translation.hooks");
const user_hooks_1 = require("@hooks/user.hooks");
const number_1 = require("@utils/object/number");
const collection_hooks_1 = require("@hooks/collection.hooks");
const collection_card_1 = require("@components/collection-card");
require("./styles.scss");
const TopSection = () => {
    const { list: collections } = (0, collection_hooks_1.useCollections)({
        sorting: "asc",
    }, { size: 7 });
    const translator = (0, translation_hooks_1.usePagesTranslation)("mainPage.topSection");
    const [activeTokenIndex, setActiveTokenIndex] = (0, react_1.useState)(0);
    const cardContainerRef = (0, react_1.useRef)(null);
    const collectionsAmount = collections.length;
    (0, react_1.useEffect)(() => {
        const cardContainer = cardContainerRef.current;
        const cards = Array.from((cardContainer === null || cardContainer === void 0 ? void 0 : cardContainer.querySelectorAll(".c-main-page-top-section__card")) || []);
        if (!cardContainer || cards.length === 0) {
            return;
        }
        setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
            const newIndex = activeTokenIndex + 1 >= collectionsAmount ? 0 : activeTokenIndex + 1;
            cardContainer.style.marginLeft = `-${newIndex * 380}px`;
            setActiveTokenIndex(newIndex);
        }), 5000);
    }, [activeTokenIndex, collectionsAmount]);
    const { loaderState: { total: totalNfts }, } = (0, token_hooks_1.useTokenListByFilter)({}, { page: 0, size: 0 });
    const { loaderState: { total: totalUsers }, } = (0, user_hooks_1.useUserList)();
    return (React.createElement("div", { className: "c-main-page-top-section" },
        React.createElement("div", { className: "c-main-page-top-section__info" },
            React.createElement("div", { style: { backgroundImage: `url(${red_brush_png_1.default})` }, className: "c-main-page-top-section__info-title" }, translator("title")),
            React.createElement("div", { className: "c-main-page-top-section__info-description" }, translator("description")),
            React.createElement("div", { className: "c-main-page-top-section__buttons" },
                React.createElement(button_1.Button, { tag: "a", buttonUrl: "/profile" }, translator("profileLinkLabel"))),
            React.createElement("div", { className: "c-main-page-top-section__info-grid" },
                React.createElement("div", { className: "c-main-page-top-section__info-grid-item" },
                    React.createElement("div", { className: "c-main-page-top-section__info-grid-value" },
                        (0, number_1.formatShortNumber)(totalNfts),
                        React.createElement("span", null, "+")),
                    React.createElement("div", { className: "c-main-page-top-section__info-grid-label" },
                        " ",
                        translator("artsLabel"))),
                React.createElement("div", { className: "c-main-page-top-section__info-grid-item" },
                    React.createElement("div", { className: "c-main-page-top-section__info-grid-value" },
                        "$",
                        (0, number_1.formatShortNumber)(134000),
                        React.createElement("span", null, "+")),
                    React.createElement("div", { className: "c-main-page-top-section__info-grid-label" },
                        " ",
                        translator("tradingVolumeLable"))),
                React.createElement("div", { className: "c-main-page-top-section__info-grid-item" },
                    React.createElement("div", { className: "c-main-page-top-section__info-grid-value" }, (0, number_1.formatShortNumber)(totalUsers)),
                    React.createElement("div", { className: "c-main-page-top-section__info-grid-label" }, translator("participatorsLabel"))))),
        React.createElement("div", { className: "c-main-page-top-section__cards-section" },
            React.createElement("div", { ref: cardContainerRef, className: "c-main-page-top-section__cards" }, collections.map((collection, index) => (React.createElement("div", { className: `c-main-page-top-section__card ${index === activeTokenIndex ? "c-main-page-top-section__card--active" : ""}` },
                React.createElement(collection_card_1.CollectionCard, { collection: collection }))))),
            React.createElement("div", { className: "c-main-page-top-section__card-nav-container" },
                Array(collectionsAmount)
                    .fill(1)
                    .map((_, index) => (React.createElement("div", { key: index, className: `c-main-page-top-section__card-nav c-main-page-top-section__card-nav--${index < activeTokenIndex ? "passed" : index === activeTokenIndex ? "progress" : "not-passed"}` }))),
                React.createElement("a", { href: "/explore/collections" }, translator("openCollectionsButton"))))));
};
exports.TopSection = TopSection;
exports.default = exports.TopSection;
